// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"map-safety"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M14.498 12.998C16.8935 12.998 19.1026 12.998 21.498 12.998V17.6317C21.498 18.307 21.1572 18.9367 20.5919 19.3061L17.998 21.0005L15.4042 19.3061C14.8389 18.9367 14.498 18.307 14.498 17.6317V12.998Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M15 6.5L9 3L3 6.5V20L9 17.5M15 6.5L21 4V9M15 6.5V9M9 17.5V3.5M9 17.5L10.5 18.375","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14.498 12.998C16.8935 12.998 19.1026 12.998 21.498 12.998V17.6317C21.498 18.307 21.1572 18.9367 20.5919 19.3061L17.998 21.0005L15.4042 19.3061C14.8389 18.9367 14.498 18.307 14.498 17.6317V12.998Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-map-safety')
export default class MapSafetyIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'map-safety',
    }
  }
}
